var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useQuery } from '@tanstack/react-query';
import { getQueueStatus } from '../services/ServiceTradeService';
// Query Keys
export const QUEUE_STATUS_QUERY_KEYS = {
    all: ['serviceTradeQueueStatus'],
    status: () => ['serviceTradeQueueStatus', 'status']
};
// Hook to fetch queue status
export function useQueueStatusQuery() {
    return useQuery({
        queryKey: QUEUE_STATUS_QUERY_KEYS.status(),
        queryFn: () => __awaiter(this, void 0, void 0, function* () {
            const response = yield getQueueStatus();
            if (response.error) {
                throw new Error(response.error.message);
            }
            if (!response.data) {
                throw new Error('No data returned from queue status');
            }
            return response.data;
        }),
        refetchInterval: 30000, // Poll every 30 seconds
        staleTime: 20000, // Consider data stale after 20 seconds
        retry: 3
    });
}
